// content-analytics.service.ts
import { Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class ContentAnalyticsService {
  constructor(private analyticsService: AnalyticsService) {}

  /**
   * Generic method for tracking content views
   * Standardizes content tracking across different content types
   */
  trackContentView(
    contentType: string,
    contentId: string,
    contentName: string,
    sourceScreen?: string
  ): Promise<any> {
    return this.analyticsService.logEvent(`${contentType}_view`, {
      content_type: contentType,
      content_id: contentId,
      item_name: contentName,
      source_screen: sourceScreen || 'unknown',
      items: [{ name: contentName }]
    });
  }

  /**
   * Track content engagement time
   */
  trackEngagementTime(
    contentType: string,
    contentId: string,
    contentName: string,
    timeSpentSeconds: number
  ): Promise<any> {
    return this.analyticsService.logEvent('engagement_time', {
      content_type: contentType,
      content_id: contentId,
      item_name: contentName,
      time_spent_seconds: timeSpentSeconds,
      items: [{ name: contentName }]
    });
  }

  /**
   * Track item sharing
   */
  trackShare(
    contentType: string,
    contentId: string,
    contentName: string,
    shareMethod: string = 'browser_options'
  ): Promise<any> {
    return this.analyticsService.logEvent('share', {
      content_type: contentType,
      content_id: contentId,
      item_name: contentName,
      method: shareMethod,
      items: [{ name: contentName }]
    });
  }

  /**
   * Track search
   */
  trackSearch(searchTerm: string, resultsCount: number): Promise<any> {
    return this.analyticsService.logEvent('top_search_view', {
      search_term: searchTerm,
      results_count: resultsCount
    });
  }

  /**
   * Track search result click
   */
  trackSearchResultClick(
    searchTerm: string,
    itemId: number,
    itemName: string,
    position: number
  ): Promise<any> {
    return this.analyticsService.logEvent('search_result_click', {
      search_term: searchTerm,
      content_id: itemId,
      item_name: itemName,
      position: position,
      items: [{ name: itemName }]
    });
  }
}
